import { render, staticRenderFns } from "./OtherEvents.vue?vue&type=template&id=e7957c00&scoped=true&"
import script from "./OtherEvents.vue?vue&type=script&lang=js&"
export * from "./OtherEvents.vue?vue&type=script&lang=js&"
import style0 from "./OtherEvents.vue?vue&type=style&index=0&id=e7957c00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7957c00",
  null
  
)

export default component.exports